
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow container mx-auto px-6 py-32 max-w-7xl">
        <h1 className="text-[2.5rem] md:text-[2.75rem] font-charter font-medium text-primary mb-8">
          Privacy Policy
        </h1>
        <div className="prose prose-lg prose-stone max-w-none">
          <p className="text-secondary italic mb-8">Effective Date: February 11, 2025</p>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">1. Introduction</h2>
          <p className="text-secondary">
            RC Capital LLC dba planniFi ("Company", "we", "our", or "us") provides a software subscription service that allows users to plan, budget, and track paid media performance advertising. Our software subscription is tailored for brand and small business owners, agencies, marketing managers, CMOs, media buyers, media planners, and other individuals or entities running paid media performance advertising. Unlike other solutions in the market that are often overly complex, expensive, and filled with unnecessary features, our platform is designed to be simple, effective, and cost-efficient. We focus on providing only the essential tools that media buyers and marketers truly need, eliminating unnecessary complexity while maintaining a high level of accuracy and usability. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">2. Information We Collect</h2>
          <p className="text-secondary">We collect the following types of data when you use our platform:</p>
          <ul className="list-disc pl-6 text-secondary">
            <li>Account Information: Name, email address, billing details, and login credentials.</li>
            <li>Advertising Data: Information pulled from API integrations with Meta, Google, TikTok, and Shopify, including campaign spend, impressions, clicks, conversion data, and other performance metrics.</li>
            <li>Usage Data: Information about how you interact with our platform, including log files, device information, and cookies.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">3. How We Use Your Information</h2>
          <p className="text-secondary">We use the information collected to:</p>
          <ul className="list-disc pl-6 text-secondary">
            <li>Provide and improve our services.</li>
            <li>Sync and display advertising and sales performance data.</li>
            <li>Generate reports and visualizations for user insights.</li>
            <li>Process payments and manage subscriptions.</li>
            <li>Ensure platform security and compliance.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">4. Data Sharing and Disclosure</h2>
          <p className="text-secondary">
            We do not sell or share user data with third parties. However, we may share data with:
          </p>
          <ul className="list-disc pl-6 text-secondary">
            <li>Third-party service providers (e.g., payment processors, cloud storage providers) to help operate our platform.</li>
            <li>Legal authorities if required by law or to enforce our Terms of Service.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">5. Data Security</h2>
          <p className="text-secondary">
            We implement industry-standard security measures to protect user data, including encryption and secure API access. However, no method of transmission over the internet is 100% secure.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">6. Data Retention</h2>
          <p className="text-secondary">
            We retain user data for as long as necessary to provide services. Users may request data deletion by contacting support.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">7. Your Rights and Choices</h2>
          <p className="text-secondary">Users may:</p>
          <ul className="list-disc pl-6 text-secondary">
            <li>Update account information via the platform settings.</li>
            <li>Disconnect API integrations at any time.</li>
            <li>Request account deletion by reaching out to support.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">8. API Data Disclaimer</h2>
          <ul className="list-disc pl-6 text-secondary">
            <li>Our platform relies on third-party API integrations with Shopify, Meta, Google, and TikTok to provide data insights.</li>
            <li>We are not responsible for any data inaccuracies, delays, or API-related outages caused by third-party platforms.</li>
            <li>Users must ensure they have the correct API credentials and permissions set up for data syncing.</li>
            <li>We do not modify or influence user advertising budgets or campaign performance beyond data reporting and visualization.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">9. Changes to This Privacy Policy</h2>
          <p className="text-secondary">
            We may update this Privacy Policy periodically. Users will be notified of any significant changes.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">10. Contact Us</h2>
          <p className="text-secondary">
            If you have any questions, contact us at{" "}
            <a href="mailto:contact@plannifi.com" className="text-primary hover:underline">
              contact@plannifi.com
            </a>
            .
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
